// extracted by mini-css-extract-plugin
export default {"wrapper":"NewsAll_wrapper__UenDi","title":"NewsAll_title__YdM15","cardWrapper":"NewsAll_cardWrapper__dq7VT"};